import { BackType, By, Timestamp } from "../../types";
import { CashActivity } from "./cash-activity/types";
import { ChequeActivity } from "./cheque-activity/types";
import { CustomerActivity } from "./customer-activity/types";
import { FactorActivity } from "./factor-activity/types";

export enum ActivityType {
  None = 0,
  Customer,
  Cheque,
  Factor,
  Cash,
}

export type ActivityData =
  | CustomerActivity
  | ChequeActivity
  | FactorActivity
  | CashActivity;

export interface Activity {
  type: ActivityType;
  data: ActivityData;
  date: Timestamp;
  by: By;
}

export enum ActivityRendererType {
  None = 0,
  Big,
  Small,
}

export interface ActivityDataWithType {
  type: ActivityRendererType;
  activity: ActivityData;
  date: Timestamp;
  by: By;
}

export interface ActivityMeta {
  type: ActivityRendererType;
  date: Timestamp;
  by: By;
}

export interface ActivityPopupMeta<T extends {}> {
  data: ActivityData;
  back?: BackType<T>;
}

export interface ActivityRendererProps<T extends {}> {
  type: ActivityRendererType;
  activity: Activity;
  back?: BackType<T>;
}

export interface ActivityPopupRendererProps<T extends {}> {
  activity: Activity;
  back?: BackType<T>;
}
